function ShowMenuImage() {
    if ($(window).width() > 992) {
        $("#MainMenu > ul > li").hover(function () {

            $BannerImage = $(this).find(".MenuBanner img");

            if ($BannerImage.attr("data-oimage") != undefined) {

                var Oiamge = $BannerImage.attr("data-oimage");
                $BannerImage.attr("src", Oiamge);
                $BannerImage.removeAttr("data-oimage");
            }
        });
    }
}

function MobileHeaderSetting() {
    if (isMobileResolution()) {
        $("#MainMenu .Mainmenu li.logo").remove();
        //$("#MainMenu .Mainmenu .itemsWrapper .ListWrapper > li").unwrap();
        $("#MainMenu ul.Mainmenu > li").each(function () {
            $(this).addClass("wrapper");
            if ($(this).has("ul").length > 0 && $(this).children("a").html() != "Markalar") { // Markaların alt katalogu vardır lakin mobil menude görünmemesi için eklenmiştir
                $(this).append("<i class='sorsfont sorsfont-arrow-right'></i>")
                $(this).children(".itemsWrapper").children(".ListWrapper").append("<li class='tumunugor'><a><i class='sorsfont-arrow-left'></i>Geri</a></li>");
            }
            $(this).remove("wrapper");
            $("#MobilMainMenu").append($(this)[0].outerHTML);
        });

        $(".Mobilmenu > ul > li").each(function () {
            if ($(this).find("> .itemsWrapper").length > 0) {
                $(this).addClass("wrapper");
            }
        });



        //$(document).on("click", "header .MainControlOuther .MainIcon, .MobileSearch i", function () {
        //    $("body .MobilMenu").toggleClass("open");
        //    $("body").toggleClass("no-scroll");
        //});


        // sol menu açmak
        $(document).on("click", "header .MainControlOuther .MainIcon,header .MainControlOuther .MobileSearch", function () {
            $("body .MobilMenu").toggleClass("open");
            $("body").toggleClass("BackDropped");
            $("body").toggleClass("no-scroll");

        });
        $(document).on("click", " #CheckoutHeader.Search .MainIcon,#CheckoutHeader.Search .MainIcon", function () {
            $("body .MobilMenu").toggleClass("open");
            $("body").toggleClass("BackDropped");
            $("body").toggleClass("no-scroll");

        });
        // Sol menu kapatmak
        $(document).on("click", ".MobilMenu .MobileMenuHeader .close-menu", function () {
            $("body .MobilMenu").removeClass("open");
            $("body").removeClass("BackDropped");
            $("body").removeClass("no-scroll");
            $(".MobilMenu .MobilMenuOuther").removeClass("open");
        });

        // 2. Listenin açılması
        $(document).on("click", ".MobilMenu .MobilMenuOuther:not(.open) #MobilMainMenu .wrapper i", function () {
            if ($(this).parent(".wrapper").find("> .itemsWrapper").length > 0 && $(this).children("a").html() != "Markalar") { // Markaların alt katalogu vardır lakin mobil menude görünmemesi için eklenmiştir
                $(this).parent(".wrapper").find("> .itemsWrapper").addClass("ShowWrapper");
                $(".MobilMenu .MobilMenuOuther").addClass("open");
                $(".MobilMenuOuther ").animate({ scrollTop: 0 }, 500, 'swing', function () { });
            }
        });

        ////geri döne
        $(document).on("click", ".MobilMenuOuther  .wrapper  .itemsWrapper .ListWrapper .tumunugor", function () {
            $(this).closest(".itemsWrapper").removeClass("ShowWrapper");
            $(".MobilMenu .MobilMenuOuther").removeClass("open");
            toggleMenusOperation("all");

        });
        //$(document).on("click", "body > .Mobilmenu .closeMobilMenu", function () {
        //    //$("body > .Mobilmenu").removeClass("open");
        //    $("body > .Mobilmenu > ul").removeClass("open");
        //    $("body > .Mobilmenu > ul > li").removeClass("open");
        //    $("body > .Mobilmenu > ul > li > ul").removeClass("open");

        //    toggleMenusOperation("all");
        //});

        $(document).on("click", "body > .Mobilmenu > ul > li > a", function () {

            if (!$(this).closest("li").hasClass("open")) {
                var openWrapper = $(".Mobilmenu ul li.wrapper.open");
                if (openWrapper.length > 0) {
                    openWrapper.removeClass("open");
                    openWrapper.closest("ul").removeClass("open");
                    openWrapper.find(".itemsWrapper").removeClass("open");
                    openWrapper.find(".itemsWrapper").removeClass("open");

                    $("html, body").stop().animate({ scrollTop: 0 }, 0, 'swing');
                }
            }

            var itemsWrapper = $(this).parent().children(".itemsWrapper");

            if (itemsWrapper.length > 0) {
                itemsWrapper.toggleClass("open");
                itemsWrapper.closest("li").toggleClass("open");
                itemsWrapper.parents("ul").toggleClass("open");

                return false;
            }
        });


        $(document).on("click", ".MobilMenu .MobileMenuFooter .login,.MobilMenu .MobileMenuFooter .loginIcon .sorsfont-arrow-right ", function () {

            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .modal-header .register-tittle").css("display", "none")
            $("#LoginRegisterModal .modal-header .login-tittle").css("display", "block")
            $("body .MobilMenu").removeClass("open");
            $(".MobilMenu .MobilMenuOuther").removeClass("open");
            $("body").removeClass("BackDropped");
        });
        $(document).on("click", ".MobilMenu .MobileMenuFooter .register", function () {

            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").show();
            $("#LoginRegisterModal .modal-header .login-tittle").css("display", "none")
            $("#LoginRegisterModal .modal-header .register-tittle").css("display", "block")
            $("body .MobilMenu").removeClass("open");
            $(".MobilMenu .MobilMenuOuther").removeClass("open");
            $("body").removeClass("BackDropped");

        });

    }
}

function DesktopHeaderSetting() {
    if (!isMobileResolution()) {
        $("#MainMenu > ul > li").live({
            mouseenter:
                function () {
                    if ($(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
                        $("body").addClass("BackDropped");
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                        $("ul#MainMenu.Monitor > li").removeClass("open");
                    }
                }
        });

        $(".RightAccount").live({
            mouseenter:
                function () {
                    if ($(this).find("#AccountMenu").length > 0) {
                        $("body").addClass("BackDropped");
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                        $("ul#MainMenu.Monitor > li").removeClass("open");
                    }
                }
        });
    }
}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > li").hover(function () {
        $BannerArea = $(this).parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        $BannerArea.attr("src", $DefaultImage);
    });
}


$(document).ready(function () {
    MobileHeaderSetting();
    DesktopHeaderSetting();
    //MenuBannerSettings();  

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 1) {
            $("header").addClass("fixed-menu");
            //CalculateHeightForLeftInfoBar(true);
        }
        else {
            $("header").removeClass("fixed-menu");
            //CalculateHeightForLeftInfoBar(false);
        }
    });

    if ($(window).scrollTop() >= 1) {
        $("header").addClass("fixed-menu");
        //CalculateHeightForLeftInfoBar(true);
    }
    else {
        $("header").removeClass("fixed-menu");
        //CalculateHeightForLeftInfoBar(false);
    }

    var isDesktop = true;
    if (isMobileResolution()) {
        isDesktop = false;
    }

    $(window).resize(function () {
        setTimeout(function () {
            setContentHeight();
        }, 1000);

        if (isMobileResolution() && isDesktop) {
            location.reload();
        }
        else if (!isMobileResolution() && !isDesktop) {
            location.reload();
        }
    });

    //Menu Events
    $(document).on("click", "header #UserMenus .RightBasket > a", function () {
        if (isMobileResolution()) {
            if ($("header").hasClass("fixed-menu") == true) {

            }
            var footerHeigh = parseInt($("header .SLI").css("height").split("px")[0]);
            var sepetIconWidth = parseInt($(" #UserMenus .RightBasket a").css("height").split("px")[0]) / 100 * 50;
            $("header #UserMenus .RightBasket .SepetProducts").css("top", footerHeigh - 2 + "px");
            $("header #UserMenus .RightBasket .polygon").css("top", footerHeigh - 3 - sepetIconWidth + "px");
            toggleMenusOperation("basket");


        } else {
            window.location.href = "/p/CheckOut/sepet"
        }
    });

    $(document).on("click", "header #UserMenus .RightBasket .SepetProducts .close-basket", function () {
        toggleMenusOperation("basket");
        $(".RightBasket .polygon").removeClass("open");

    });
    // END Menu Events

    // Account Events
    //$(document).on("click", "header #UserMenus .RightAccount > a", function () {
    //    toggleMenusOperation("account");
    //});

    $(document).on("click", ".contentTopSpace > .AccountMenu .AccountHeader .close-account", function () {
        toggleMenusOperation("all");
    });
    // END Account Events

    if ($("#UserAndBasket").length > 0) {
        GetSepetIcerik(function (dt) {
            $("#UserAndBasket").html(dt);
            generateToolTip();
        });
    }

    $(".BasketContainer .RemoveIcon").live("click", function () {
        var LangID = $("#LangID").val();
        var dataall = "";
        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {
            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        if ($(this).attr("data-all") == "true") {
            dataall = "&all=true";
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        RemoveFromCardForMiniCard(Silid, LangID, dataall);
    });
});